<template>
  <ChartCard>
    <ChartHeader label>
      <v-skeleton-loader
        type="text"
        min-width="100%"
        height="20px"
        class="header-text"
      />
    </ChartHeader>
    <div class="req-fill-rate-loader-header-row">
      <div v-for="i in 6" :key="i">
        <v-skeleton-loader type="text" height="12px" width="100%" />
      </div>
    </div>
    <div class="req-fill-rate-loader-body w-100 d-flex flex-column align-center justify-center">
      <DpplSkeletonLoader class="mb-3">
        <div class="large-icon-loader" />
      </DpplSkeletonLoader>
      <v-skeleton-loader class="mb-3" type="text" height="12px" width="123px" />
      <v-skeleton-loader class="mb-3" type="text" height="12px" width="123px" />
      <v-skeleton-loader type="text" height="12px" width="123px" />
    </div>
  </ChartCard>
</template>

<script setup>
import ChartCard from '@/components/insights/Chart/ChartCard.vue';
import ChartHeader from '@/components/insights/Chart/ChartHeader.vue';
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
</script>

<style lang="less" scoped>
:deep(.v-skeleton-loader__text) {
  margin: 0 !important;
}

.req-fill-rate-loader-header-row {
  width: 100%;
  height: 36px;
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
  background: fade(@grey-900, 5%);
  border-bottom: 1px solid @stroke-default;
}

.req-fill-rate-loader-body {
  height: 515px;
}

.large-icon-loader {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background: fade(@grey-900, 15%);
}
</style>
